"use client";

import React from "react";

import { SVGIcon } from "../SVGIcon";
import { createSVGIcon } from "../util";

/** @optimized using svgo:^3.0.2 */
export const EyeOpen = createSVGIcon(
  <>
    <path
      d="M.075 12.406a.534.534 0 0 0 0 .688c.113.133 1.495 1.745 3.593 3.325s4.916 3.131 7.903 3.131 5.806-1.552 7.903-3.13c2.099-1.58 3.48-3.193 3.593-3.326a.53.53 0 0 0 .03-.646c-.093-.136-1.236-1.76-3.224-3.348-1.988-1.59-4.825-3.15-8.302-3.15-2.987 0-5.806 1.552-7.903 3.13C1.57 10.66.188 12.274.075 12.407Zm11.496 6.08c-2.366 0-4.679-1.13-6.547-2.418a24.3 24.3 0 0 1-3.826-3.318 24 24 0 0 1 3.823-3.319c1.867-1.288 4.18-2.417 6.55-2.417 2.773 0 5.14 1.128 6.934 2.412a17.7 17.7 0 0 1 3.467 3.295 24.3 24.3 0 0 1-3.81 3.32c-1.875 1.3-4.204 2.445-6.59 2.445Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth=".1"
    />
    <path
      d="M11.571 8.843a3.91 3.91 0 0 0-3.907 3.907 3.91 3.91 0 0 0 3.907 3.907 3.91 3.91 0 0 0 3.907-3.907 3.91 3.91 0 0 0-3.907-3.907Zm0 6.75a2.846 2.846 0 0 1-2.843-2.843 2.846 2.846 0 0 1 2.843-2.843 2.846 2.846 0 0 1 2.843 2.843 2.846 2.846 0 0 1-2.843 2.843Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth=".1"
    />
  </>,
  "EyeIcon",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    fill: "none",
    titleAccess: strictLocalize({
      defaultMessage: "Show password",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
  })
);

/** @optimized using svgo:^3.0.2 */
export const EyeClosed = createSVGIcon(
  <>
    <path
      d="M15.212 9.915a.48.48 0 0 0-.678.678c.543.542.842 1.264.842 2.032a2.88 2.88 0 0 1-2.874 2.875c-.77 0-1.49-.299-2.033-.842a.48.48 0 0 0-.678.678 3.8 3.8 0 0 0 2.71 1.123 3.837 3.837 0 0 0 3.834-3.834 3.8 3.8 0 0 0-1.123-2.71M13.17 8.858a4 4 0 0 0-.668-.066 3.837 3.837 0 0 0-3.834 3.834c0 .228.028.45.067.667a.48.48 0 0 0 .943-.166 3 3 0 0 1-.051-.502 2.88 2.88 0 0 1 2.875-2.875c.172 0 .338.023.5.051a.478.478 0 1 0 .168-.943"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.187 8.76a.58.58 0 0 1-.203 1.14 3 3 0 0 0-.482-.05 2.78 2.78 0 0 0-2.775 2.776c0 .164.02.323.05.483a.58.58 0 0 1-.571.68.58.58 0 0 1-.57-.478 4 4 0 0 1-.068-.685 3.937 3.937 0 0 1 3.934-3.934c.236 0 .464.029.685.068"
      fill="currentColor"
    />
    <path
      d="M23.886 12.318c-.108-.129-2.7-3.154-6.276-5.007a.48.48 0 0 0-.44.852c2.755 1.427 4.955 3.652 5.707 4.464-1.142 1.238-5.638 5.75-10.377 5.75-1.608 0-3.228-.388-4.818-1.154a.478.478 0 1 0-.416.862c1.72.831 3.482 1.25 5.234 1.25 5.905 0 11.166-6.136 11.387-6.398a.48.48 0 0 0 0-.62"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.656 7.223c3.594 1.862 6.196 4.9 6.307 5.03a.58.58 0 0 1 0 .749c-.113.134-1.49 1.74-3.578 3.312s-4.9 3.122-7.885 3.122c-1.769 0-3.545-.424-5.278-1.26a.578.578 0 1 1 .503-1.043c1.578.76 3.184 1.145 4.775 1.145 2.34 0 4.628-1.115 6.48-2.394a24 24 0 0 0 3.76-3.256l.064.067.073-.068-.073-.067-.063.068c-.804-.86-2.951-2.996-5.617-4.376a.579.579 0 1 1 .532-1.03m-.692.295a.48.48 0 0 0 .206.645Zm.646-.207a.48.48 0 0 0-.646.207Z"
      fill="currentColor"
    />
    <path
      d="M15.645 6.47c-1.09-.367-2.149-.552-3.144-.552-5.905 0-11.166 6.137-11.388 6.399a.48.48 0 0 0-.026.583c.066.095 1.65 2.345 4.396 4.168a.475.475 0 0 0 .663-.135.48.48 0 0 0-.134-.663 17.5 17.5 0 0 1-3.913-3.618C3.202 11.454 7.727 6.876 12.5 6.876c.892 0 1.847.169 2.838.501a.473.473 0 0 0 .607-.3.48.48 0 0 0-.301-.607"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.087 12.9a.48.48 0 0 1 .026-.583c.222-.262 5.483-6.4 11.388-6.4.995 0 2.053.186 3.144.553a.48.48 0 0 1 .3.607.473.473 0 0 1-.606.3c-.99-.332-1.946-.5-2.838-.5-4.774 0-9.3 4.577-10.402 5.775a17.5 17.5 0 0 0 3.913 3.618c.22.146.28.444.134.663a.475.475 0 0 1-.663.135c-2.746-1.824-4.33-4.073-4.396-4.168m4.34 4.251c-2.76-1.833-4.353-4.094-4.422-4.193a.58.58 0 0 1 .032-.706c.114-.135 1.49-1.74 3.579-3.313 2.087-1.571 4.9-3.121 7.885-3.121 1.008 0 2.076.187 3.176.557.303.102.465.43.364.733a.573.573 0 0 1-.735.364c-.982-.33-1.926-.496-2.805-.496-2.357 0-4.661 1.131-6.52 2.421a24 24 0 0 0-3.75 3.26c.55.692 1.897 2.24 3.836 3.53a.578.578 0 0 1-.32 1.062.57.57 0 0 1-.32-.098"
      fill="currentColor"
    />
    <path
      d="M20.984 4.14a.48.48 0 0 0-.677 0L4.015 20.433a.48.48 0 0 0 .677.678L20.984 4.818a.48.48 0 0 0 0-.677"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.944 21.18a.58.58 0 0 1 0-.818L20.236 4.07a.58.58 0 0 1 .819.819L4.763 21.18a.577.577 0 0 1-.819 0m.07-.07a.48.48 0 0 1 0-.678L20.308 4.141a.48.48 0 0 1 .677.677L4.692 21.11a.477.477 0 0 1-.677 0"
      fill="currentColor"
    />
  </>,
  "EyeClosedIcon",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    fill: "none",
    titleAccess: strictLocalize({
      defaultMessage: "Hide password",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
  })
);

export const Eye = React.memo(
  ({
    closed,
    ref,
    ...props
  }: SVGIcon.IProps & {
    closed?: boolean;
  } & React.RefAttributes<SVGElement>) => {
    const IconComponent = closed ? EyeClosed : EyeOpen;
    return <IconComponent ref={ref} {...props} />;
  }
);
